export enum ESolarPlantSize {
  UNSPECIFIED = "UNSPECIFIED",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  EXTRA_LARGE = "EXTRA_LARGE",
}
